import React from "react";
import "./ContactDetails.css";
import { BsEnvelopeAt, BsFillGeoAltFill } from "react-icons/bs";
import ContactItem from "./ContactItem";

const ContactDetails = () => {
  return (
    <>
      <div className="separator"></div>
      <ul className="contacts-list">
        <ContactItem
          icon={BsEnvelopeAt}
          title="Email"
          link="mailto:muthupalani9999@gmail.com"
          value="muthupalani9999@gmail.com"
        />

        <ContactItem
          icon={BsFillGeoAltFill}
          title="Location"
          value="Chennai, Tamil Nadu, India"
        />
      </ul>
    </>
  );
};

export default ContactDetails;
